import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

const size = 90;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'fixed',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      backgroundColor: theme.palette.grey[50],
      zIndex: 1400, //higher than modal
      opacity: 0.5,
    },
    progress: {
      margin: theme.spacing(2),
      position: 'relative',
      left: `calc(50% - ${size / 2}px)`,
      top: `calc(50% - ${size / 2}px)`,
    },
  })
);

const Spinner = ({ visible }: { visible: boolean }) => {
  const classes = useStyles();
  return visible === true ? (
    <div className={classes.root}>
      <CircularProgress size={size} className={classes.progress} />
    </div>
  ) : null;
};

export default Spinner;
